import { get, isEmpty } from 'lodash';

import rootStore from '../store/store';

const { store } = rootStore;

const EMPTY_MAP = {};
let supportedCurrencyMapCache = EMPTY_MAP;
let prevCurrencies = null;
let prevOverrides = null;

const applyCurrencySymbolOverrides = (currencies = [], overrideCurrencySymbol = {}) => {
  if (!Array.isArray(currencies) || !currencies.length) {
    return currencies;
  }
  if (isEmpty(overrideCurrencySymbol)) {
    return currencies;
  }
  return currencies.map((currency) => {
    const code = get(currency, 'code', '');
    const overrideDisplayCode = get(overrideCurrencySymbol, code, '');
    if (!overrideDisplayCode) {
      return currency;
    }
    return { ...currency, displayCode: overrideDisplayCode };
  });
};

export const selectSupportedCurrencies = () => {
  const state = store.getState();
  const currencies =
    get(state, 'app.masterData.referenceData.supportedCurrencies') ||
    get(state, 'common.masterData.referenceData.supportedCurrencies') ||
    [];
  const safeCurrencies = Array.isArray(currencies) ? currencies : [];
  const overrideCurrencySymbol = get(state, 'common.resources.overrideCurrencySymbol', {});
  return applyCurrencySymbolOverrides(safeCurrencies, overrideCurrencySymbol);
};

export const buildSupportedCurrencyMap = (currencies = []) => {
  const map = {};
  if (!Array.isArray(currencies)) {
    return map;
  }
  currencies.forEach((currency) => {
    const code = get(currency, 'code', '');
    map[code] = currency;
  });
  return map;
};

export const syncSupportedCurrenciesFromState = () => {
  const state = store.getState();
  const currencies =
    get(state, 'app.masterData.referenceData.supportedCurrencies') ||
    get(state, 'common.masterData.referenceData.supportedCurrencies') ||
    null;
  const overrideCurrencySymbol = get(state, 'common.resources.overrideCurrencySymbol', null);

  if (currencies === prevCurrencies && overrideCurrencySymbol === prevOverrides) {
    return supportedCurrencyMapCache;
  }

  prevCurrencies = currencies;
  prevOverrides = overrideCurrencySymbol;

  const safeCurrencies = Array.isArray(currencies) ? currencies : [];
  const finalCurrencies = applyCurrencySymbolOverrides(safeCurrencies, overrideCurrencySymbol || {});
  supportedCurrencyMapCache = buildSupportedCurrencyMap(finalCurrencies);
  return supportedCurrencyMapCache;
};

export const getCurrencyDisplaySymbol = (currencyCode, supportedCurrencyMap) => {
  const map = supportedCurrencyMap ? supportedCurrencyMap : supportedCurrencyMapCache;
  const currency = get(map, currencyCode, {});
  return get(currency, 'displayCode', '') || '';
};
